import { useEffect, useState } from "react";
import api from "../../../Component/axios";

export const useVariedad = (id_cultivo) => {
  const token = localStorage.getItem("@Token");
  const [variedad, setVariedad] = useState([]);
  const [isVariedadLoading, setIsVariedadLoading] = useState(false);

  useEffect(() => {
    const getVariedades = async () => {
      setIsVariedadLoading(true);
      try {
        const response = await api.get(
          `api/cultivo/variedad/?id_cultivo=${id_cultivo}`,
          {
            headers: {
              Authorization: "Token " + token,
            },
          }
        );
        console.log(response.data);
        setVariedad(response.data);
      } catch (error) {
        console.log(error);
      } finally {
        setIsVariedadLoading(false);
      }
    };
    if (id_cultivo !== 0) {
      getVariedades();
    }
  }, [id_cultivo, token]);

  return { variedad, isVariedadLoading };
};
